//Youtube Player Code
export const loadYTPlayer = () => {
  window.onYouTubeIframeAPIReady = () => {
    let YT = window.YT || {};

    window.player = new YT.Player('player', {
      height: '390',
      width: '640',
      events: {
        'onReady': window.onPlayerReady,
        'onStateChange': window.onPlayerStateChange
      }
    });
  };

  window.onPlayerReady = (event) => {
    event.target.cuePlaylist({
      "listType": "playlist",
      "list": "PLziM9Uia5X2mWFlg5oC7MEa-ACLSNbV63"
    });
  };

  window.done = false;

  window.onPlayerStateChange = (event) => {
    let YT = window.YT || {};

    if (event.data == YT.PlayerState.PLAYING && !window.done) {
      setTimeout(window.stopVideo, 6000);
      window.done = true;
    }
  };

  window.stopVideo = () => {
    window.player.stopVideo();
  };

  let tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";

  let firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
};



// WEBPACK FOOTER //
// ./src/tools/ytPlayer.js